import React from 'react';
import {
  Cloud,
  Code,
  Shield,
  Database,
  Mail,
  Github,
  Phone,
  MapPin,
  Menu,
  X,
  Send,
  ExternalLink
} from 'lucide-react';

const Icons = {
  cloud: Cloud,
  code: Code,
  shield: Shield,
  database: Database,
  email: Mail,
  github: Github,
  phone: Phone,
  location: MapPin,
  menu: Menu,
  close: X,
  send: Send,
  external: ExternalLink,
} as const;

interface IconProps {
  name: keyof typeof Icons;
  size?: number;
  className?: string;
}

export const Icon: React.FC<IconProps> = ({ name, size = 24, className = "" }) => {
  const IconComponent = Icons[name];

  if (!IconComponent) return null;

  return (
    <IconComponent 
      size={size} 
      className={`text-white ${className}`}
      strokeWidth={1.5}
    />
  );
};

export default Icon;